import React, {memo} from 'react'
import {EmptyDiv} from '../CompanyDetail/CompanyDetail.css'
import {ICompanyInfo} from '../CompanyDetail/type'
import {ImageWrapper} from './Benefit.css'
import Image from 'next/image'

import {useStore} from '../../store'
import {Col, Row} from '@microfrontends/react-components'
import CollapseBenefitCard from './CollapseBenefitCard'
import BenefitCard from './BenefitCard'
import {TInfoCompanyOCI} from '../../services/companyDetailService'
import {ELanguage, initialDataProvider} from '@microfrontends/app-shell-v2'

interface IBenefitProps {
    companyInfo: ICompanyInfo | null
    t: (text: string) => string
    ociData: TInfoCompanyOCI | null | undefined
}

const EMPTY_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_URL}/company-assets/images/icon-benefits1x.png`

const Benefit = (props: IBenefitProps) => {
    const { t, companyInfo, ociData } = props
    const { isMobile, langCode } = useStore().state

    let companyBenefits
    if (companyInfo?.companyBenefits && companyInfo?.companyBenefits.length > 0) {
        const benefits = initialDataProvider.getBenefits()
        companyBenefits = companyInfo?.companyBenefits.map((item) => {
            const benefitItem = benefits.filter((childItem) => childItem.id === item.benefitId)
            return {
                ...item,
                benefitName: langCode === ELanguage.VI ? benefitItem[0]?.name : benefitItem[0]?.nameEn
            }
        })
    }
    if (ociData?.benefits && ociData.benefits.length > 0) {
        companyBenefits = ociData?.benefits
    }

    return (
        <div>
            <h2>{t('Benefits')}</h2>
            {!companyBenefits && (
                <EmptyDiv>
                    <ImageWrapper>
                        <Image
                            src={EMPTY_IMAGE}
                            alt={t('The company has not defined the benefits yet.')}
                            layout='fill'
                        />
                    </ImageWrapper>
                    <p>{t('The company has not defined the benefits yet.')}</p>
                </EmptyDiv>
            )}
            {companyBenefits && companyBenefits.length && (
                <Row gutter={16}>
                    {companyBenefits.map((benefit, index) => {
                        return (
                            <Col sm={8} xs={24} key={index}>
                                {isMobile ? (
                                    <CollapseBenefitCard benefit={benefit} />
                                ) : (
                                    <BenefitCard benefit={benefit} />
                                )}
                            </Col>
                        )
                    })}
                </Row>)
            }
        </div>
    )
}

export default memo(Benefit)
